import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    loadMore: (count: number) => string | React.ReactNode;
    noProjects: string;
    recent: string;
    spinnerAriaLabel: string;
    navSpinnerLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label to load more projects */
            loadMore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "WorkspaceGroup.loadMore?c=1vwza9qz22yvf", defaultMessage: "+{count} More" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state message when workspace has no projects */
            noProjects: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceGroup.noProjects?c=1fa6ikdd2mimp", defaultMessage: "No projects in this workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for recent projects */
            recent: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceGroup.recent?c=i947fswq5v0l", defaultMessage: "Recent" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the spinner */
            spinnerAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceGroup.spinnerAriaLabel?c=25d15suvch2eq", defaultMessage: "Spinner" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the navigation loading spinner */
            navSpinnerLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceGroup.navSpinnerLabel?c=1kfa6155xyb26", defaultMessage: "Loading more workspaces" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
